import React, { useState } from 'react';
import { IoMdArrowDropdown } from "react-icons/io";
import Collapse from 'react-bootstrap/Collapse';
import { faqQuestions } from '../../constant.js';

const Faqs = ({ faqList = faqQuestions }) => {
    const [activeFaq, setActiveFaq] = useState(0);

    const toggleFaq = (index) => {
        if (activeFaq !== index) {
            setActiveFaq(index);
        }
    };

    const parseAnswer = (answer) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return answer.replace(
            urlRegex,
            (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
        );
    };

    return (
        <div>
            <h2 style={{ color: "var(--text-color)", }}>
                <span
                    style={{
                        background: "var(--primary-gradient-100)",
                        backgroundClip: "text",
                        WebkitTextFillColor: "transparent"
                    }}>
                    Frequently Asked</span>&nbsp;Questions</h2>
            <p style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", lineHeight: "24px" }}>Contact Us anytime if you have anymore questions!</p>
            <div className="pt-5 pb-5">
                {
                    faqList.map((item, index) => (
                        <div
                            className="mt-2"
                            onClick={() => toggleFaq(index)}
                            aria-expanded={activeFaq === index}
                            aria-controls={`faq${index}`}
                            style={{
                                background: activeFaq === index ? "var(--primary-gradient-100)" : "transparent",
                                padding: "2px",
                                borderRadius: "12px",
                                cursor: "pointer",
                                transition: "background 0.5s ease-in-out"
                            }}
                        >
                            <div
                                className="p-3 text-start"
                                style={{
                                    borderRadius: "10px",
                                    backgroundColor: activeFaq === index ? "#FEFEFF" : "#FCFAF8",
                                    transition: "background-color 0.5s ease-in-out"
                                }}
                            >
                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 style={{ fontSize: "20px", fontWeight: "600", color: "var(--text-color)", lineHeight: "30px" }}>
                                        {item.question}
                                    </h3>
                                    <div
                                        className="p-1 rounded-2"
                                        style={{
                                            background: "var(--primary-gradient-10)",
                                            height: "fit-content",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            transform: activeFaq === index ? "rotate(180deg)" : "rotate(0deg)",
                                            transition: "transform 0.5s ease-in-out"
                                        }}
                                    >
                                        <IoMdArrowDropdown style={{ height: "20px", width: "20px" }} />
                                    </div>
                                </div>
                                <Collapse in={activeFaq === index}>
                                    <div id={`faq${index}`}>
                                        {item.answer ?
                                            <p style={{ fontSize: "18px", fontWeight: "400", color: "var(--light-black)", lineHeight: "24px", width: "90%" }}
                                                dangerouslySetInnerHTML={{ __html: parseAnswer(item.answer) }}
                                            ></p>
                                            : <></>
                                        }
                                        {
                                            item.bullets ?
                                                <ul style={{ fontSize: "18px", fontWeight: "400", color: "var(--light-black)", lineHeight: "24px", width: "90%" }}>
                                                    {
                                                        item.bullets.map((point, index) => (
                                                            <li className='my-1' style={{ listStyle: "square outside" }}>{point}</li>
                                                        ))
                                                    }
                                                </ul>
                                                : <></>
                                        }
                                    </div>
                                </Collapse>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div >
    );
}

export default Faqs;